//workspaces/Onyx/onyxf/src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
// @ts-ignore: side-effect CSS import, handled by bundler configuration
import './index.css';
import { AuthProvider } from './contexts/AuthContext';
import ToastProvider from './components/ToastProvider';
import AppRoutes from './routes';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ToastProvider>
        <AppRoutes />
      </ToastProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();